module["exports"] = [
  "gmail.com",
  "zoznam.sk",
  "azet.sk"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/internet/free_email.js
// module id = 1660
// module chunks = 0